import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LogInData } from './../../models/log-in-data.model';
import { AuthService } from './../../services/auth.service';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss'],
})
export class LogInComponent implements OnInit {
  model = new LogInData();
  loginFormGroup: FormGroup;
  showPassword = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {
    this.model = new LogInData();

    this.loginFormGroup = this.formBuilder.group({
      email: [this.model.email, Validators.email],
      password: [this.model.password, Validators.required],
    });
  }

  ngOnInit(): void {}

  login() {
    if (this.loginFormGroup.valid) {
      this.model.email = this.loginFormGroup.controls['email'].value;
      this.model.password = this.loginFormGroup.controls['password'].value;
      this.authService.setRedirectUrl(this.router.url + '/dashboard');
      this.authService.login(this.model);
    }
  }
}
